// src/components/Welcome/Welcome.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import "./Welcome.css";
import iconEvento from "../../assets/home/evento_1.png";

const eventosDelDia = [
  {
    titulo: "Muestra teatral El Quijote",
    fecha: "15 de agosto 2023 | 18:40 pm",
    lugar: "Av. Arboleda Surco - Lima",
    asistentes: 120,
    inicialesUsuarios: ["I", "A", "E"],
    imagen: iconEvento,
  },
  {
    titulo: "Conservatorio de Lima en concierto",
    fecha: "15 de agosto 2023 | 18:40 pm",
    lugar: "Av. Arboleda Surco - Lima",
    asistentes: 120,
    inicialesUsuarios: ["I", "A", "E"],
    imagen: iconEvento,
  },
  {
    titulo: "Muestra teatral El Quijote",
    fecha: "15 de agosto 2023 | 18:40 pm",
    lugar: "Av. Arboleda Surco - Lima",
    asistentes: 120,
    inicialesUsuarios: ["I", "A", "E"],
    imagen: iconEvento,
  },
];
const proximosEventos = [...eventosDelDia, ...eventosDelDia];

function BadgeUsuarios({ iniciales }) {
  const coloresCirculos = ["#00C2FF", "#97C100", "#FF2D52"];
  return (
    <span className="users-badge-group">
      {iniciales.map((letra, idx) => (
        <span
          key={idx}
          className="badge-circulo"
          style={{
            backgroundColor: coloresCirculos[idx % coloresCirculos.length],
            marginRight: idx < iniciales.length - 1 ? "-8px" : "10px",
            zIndex: 10 - idx,
            border: "2px solid #fff",
          }}
        >
          {letra}
        </span>
      ))}
    </span>
  );
}

function CardEvento({ evento }) {
  return (
    <div className="evento-card shadow-sm">
      <img src={evento.imagen} alt={evento.titulo} className="evento-img-top" />
      <div className="evento-card-body px-3 pt-3">
        <div className="evento-fecha small text-muted fw-bold mb-2">
          {evento.fecha}
        </div>
        <div className="evento-titulo fw-bold mb-1">{evento.titulo}</div>
        <div className="evento-lugar text-muted mb-2">{evento.lugar}</div>
        <div className="d-flex align-items-center">
          <BadgeUsuarios iniciales={evento.inicialesUsuarios} />
          <span className="asistentes-text small text-muted ms-1 fw-bold">
            {evento.asistentes} asistentes
          </span>
        </div>
      </div>
    </div>
  );
}

export default function Welcome() {
  const navigate = useNavigate();
  const [nombreUsuario, setNombreUsuario] = useState("");
  const [searchText, setSearchText] = useState("");
  const [modalidad, setModalidad] = useState("Virtual");
  const [ciudad, setCiudad] = useState("Lima");
  const [distrito, setDistrito] = useState("Miraflores");

  const modalidades = ["Virtual", "Presencial"];
  const ciudades = ["Lima", "Arequipa", "Cusco"];
  const distritos = ["Miraflores", "Barranco", "Surco"];

  // 🔑 Lógica de seguridad y obtención de datos del usuario
  useEffect(() => {
    const token = localStorage.getItem("userToken");

    if (!token) {
      // Si no hay token, redirige al login.
      navigate("/login");
      return;
    }

    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      // Si el token ha expirado, redirige al login.
      if (decodedToken.exp < currentTime) {
        localStorage.removeItem("userToken");
        navigate("/login");
        return;
      }

      // Si el token es válido, extrae el nombre de usuario y actualiza el estado.
      setNombreUsuario(decodedToken.nombreuser || "");
    } catch (error) {
      // En caso de que el token sea inválido (formato incorrecto), redirige.
      console.error("Token inválido:", error);
      localStorage.removeItem("userToken");
      navigate("/login");
    }
  }, [navigate]);

  return (
    <div className="welcome-bg py-4">
      <main className="welcome-content container mt-3 pb-5">
        {/* Bienvenida */}
        <div className="pt-4 pb-3">
          <h1 className="bienvenida-title mt-5">
            Bienvenido <span className="nombre-usuario">{nombreUsuario}</span>!
          </h1>
          <h2 className="fw-normal bienvenida-subtitle mb-3">
            Empecemos a conectar
          </h2>

          {/* Filtros */}
          <form className="d-flex flex-wrap gap-2 mb-4 filtros-eventos align-items-center">
            <div
              className="position-relative flex-grow-1"
              style={{ minWidth: "220px" }}
            >
              <span className="position-absolute top-50 translate-middle-y ps-3 text-muted">
                <i className="bi bi-search fs-5"></i>
              </span>
              <input
                type="search"
                className="form-control ps-5 pe-5"
                placeholder="Palabra clave del evento"
                aria-label="Buscar evento por palabra clave"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <select
              className="form-select filtro-select"
              value={modalidad}
              onChange={(e) => setModalidad(e.target.value)}
              aria-label="Seleccionar modalidad"
              style={{ minWidth: 140 }}
              id="cbomodalidad"
            >
              {modalidades.map((mod) => (
                <option key={mod} value={mod}>
                  {mod}
                </option>
              ))}
            </select>

            <select
              className="form-select filtro-select"
              value={ciudad}
              onChange={(e) => setCiudad(e.target.value)}
              aria-label="Seleccionar ciudad"
              style={{ minWidth: 120 }}
            >
              {ciudades.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>

            <select
              className="form-select filtro-select"
              value={distrito}
              onChange={(e) => setDistrito(e.target.value)}
              aria-label="Seleccionar distrito"
              style={{ minWidth: 140 }}
            >
              {distritos.map((d) => (
                <option key={d} value={d}>
                  {d}
                </option>
              ))}
            </select>
          </form>
        </div>

        {/* Eventos del día */}
        <section className="section-eventos mb-5">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h3 className="fw-bold eventos-section-title mb-0">
              Eventos del día
            </h3>
            <a href="/list-group" className="ver-grupos-link fw-bold">
              Ver grupos
            </a>
          </div>
          <div className="row row-cols-1 row-cols-md-3 g-4">
            {eventosDelDia.map((evento, idx) => (
              <div className="col" key={idx}>
                <CardEvento evento={evento} />
              </div>
            ))}
          </div>
        </section>

        {/* Próximos eventos */}
        <section className="section-eventos">
          <h4 className="fw-bold text-muted eventos-section-title mb-3">
            Próximos eventos
          </h4>
          <div className="row row-cols-1 row-cols-md-3 g-4">
            {proximosEventos.map((evento, idx) => (
              <div className="col" key={idx}>
                <CardEvento evento={evento} />
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
